import { ECompletionYearType } from '../../../JsonQuery/types';

export const AVAILABLE_COMPLETION_YEAR_TYPES = [
  ECompletionYearType.CurrentYear,
  ECompletionYearType.InOneYear,
  ECompletionYearType.InTwoYears,
  ECompletionYearType.InThreeYears,
];
